var __lastPageLink;
document.addEventListener("DOMContentLoaded", function () {
  var infiniteScroll = {
    init: function () {
      this.fetchNextPage();
    },

    fetchNextPage: function () {
      window.addEventListener("scroll", () => {
        var grid = document.querySelector(".grid");
        if (grid) {
        var gridBottom = grid.offsetTop + grid.offsetHeight;
        }

        var scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
        var windowHeight = window.innerHeight;
        var scrollPosition = scrollTop + windowHeight;

        var distanceToGridBottom = gridBottom - scrollPosition;

        var nextPageLink = document.querySelector(".pagination .next a");
        if (
          distanceToGridBottom < 200 && nextPageLink &&
          nextPageLink.href !== __lastPageLink
        ) {
          if (nextPageLink && !nextPageLink.classList.contains("loading")) {
            var loadMoreView = document.querySelector(".loadMore");
            loadMoreView.style.display = "block";
            this.loadMoreBlogs(nextPageLink.href);
            __lastPageLink = nextPageLink.href;
            nextPageLink.classList.add("loading");
          } else {
            // Do nothing
          }
        } else {
          var loadMoreView = document.querySelector(".loadMore");
          if (loadMoreView) {
          loadMoreView.style.display = "none";
          }
        }
      });
    },

    loadMoreBlogs: function (url) {
      if (!url) return;

      fetch(url)
        .then((response) => response.text())
        .then((data) => {
          var parser = new DOMParser();
          var doc = parser.parseFromString(data, "text/html");
          var newblogs = doc.getElementById("collectionGrid").innerHTML;
          var newNextPageLink = doc.querySelector(".pagination .next a");

          document
            .getElementById("collectionGrid")
            .insertAdjacentHTML("beforeend", newblogs);

          var paginationContainer = document.querySelector(".pagination");
          paginationContainer.style.display = "none";

          if (newNextPageLink) {
            paginationContainer.querySelector(".next a").href =
              newNextPageLink.href;
            paginationContainer
              .querySelector(".next a")
              .classList.remove("loading");
          } else {
            paginationContainer.remove();
            var loadMoreView = document.querySelector(".loadMore");
            loadMoreView.style.display = "none";
          }

          if (typeof Yotpo !== "undefined" && Yotpo.API) {
            var api = new Yotpo.API(yotpo);
            api.refreshWidgets();
          }
        });
    },
  };

  infiniteScroll.init();
});